import React, { ReactNode } from 'react';

type SidePanelBlockProps = {
  children: ReactNode;
  style?: React.CSSProperties;
};

/**
 * 通用側邊面板容器。
 * 提供標準的 100% 寬高、flex column 佈局，
 * 供 MembersPanel、DocAreaPanel 等各類側邊面板使用。
 * 可透過 style prop 覆寫額外樣式。
 */
export function SidePanelBlock({ children, style }: SidePanelBlockProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: 'var(--curve-bg-white, #FFFFFF)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
